
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/av-central/[name_url]",
      function () {
        return require("private-next-pages/av-central/[name_url].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/av-central/[name_url]"])
      });
    }
  